import { appInfo } from "@/common/data/appinfo";
export default [
  {
    path: "/B47xefd99c9d0af2a6b100c6212aciSQWSp",
    children: [
      {
        path: "/Nv95pfe99d6fd8f2c3858f1fa3a8b459a2c462d0f295xqHkUfB",
        name: "department_comments",
        meta: {
          title: `${
            appInfo?.type == "codsms" ? "Section Class" : "Department"
          } Comments`,
          authRequired: true,
          acc: ["y132838"],
        },
        component: () => import("@/views/department-comment/index.vue"),
      },
      {
        path: "/L23fdd65b681c99782a11e40e9acad6hjOhwYxW",
        name: "department_comment_add",
        meta: {
          title: `Add ${
            appInfo?.type == "codsms" ? "Section Class" : "Department"
          } Comment`,
          authRequired: true,
          acc: ["y1329138"],
        },
        component: () => import("@/views/department-comment/upload.vue"),
      },
    ],
  },
];
